/*
 * Purpose: Guest mode banner — contextual upgrade path when save/run blocked
 * Last modified: 2026-07-01 | Agent
 * Completeness: 100
 */
import { Link } from 'react-router-dom';
import { UserRound } from 'lucide-react';
import { useSubscriptionGate } from '@/hooks/useSubscriptionGate';
import { APP_ROUTES } from '@/lib/appRoutes';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export function GuestModeBanner({ className }: { className?: string }) {
  const { isGuest, tier } = useSubscriptionGate();

  if (!isGuest && tier) return null;

  if (!isGuest && !tier) return null;

  return (
    <div
      className={cn(
        'shrink-0 border-b border-amber-500/30 bg-amber-500/10 px-4 py-2 flex flex-col sm:flex-row sm:items-center gap-2 text-sm',
        className
      )}
      role="status"
    >
      <div className="flex items-start gap-2 min-w-0 flex-1">
        <UserRound className="h-4 w-4 shrink-0 text-amber-700 dark:text-amber-400 mt-0.5" />
        <p className="text-amber-900 dark:text-amber-100 text-xs sm:text-sm">
          {isGuest
            ? 'Guest mode — you can explore the app but cannot save or run flows.'
            : 'No plan selected — choose Basic or Plus to save and run flows.'}
        </p>
      </div>
      <Button size="sm" actionTier="secondary" className="shrink-0 h-8" asChild>
        <Link to={APP_ROUTES.pricing}>Choose plan</Link>
      </Button>
    </div>
  );
}

export default GuestModeBanner;
